import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import navigation from '@/menu-items';
import { useAuthContext } from '@/providers';
import { NavItemType } from '@/types/menu';
import { hasPermission } from './use-has-permission';

// ==============================|| NOMENCLATOARE - TABS FILTERED BY PERMISSION ||============================== //

// Taburile din meniul „Administrare → Nomenclatoare", filtrate exact ca rutele:
// un tab e vizibil doar dacă utilizatorul deține `requiredPermission` (superadmin le vede pe toate).
// Titlurile intrărilor de meniu sunt chei i18n (grupul menu.*) — le traducem AICI, în hook,
// ca toți consumatorii (care randează `tab.title` direct) să primească etichete gata traduse
// și actualizate live la editările din Gestionare texte (`t` e în deps-urile memo-ului).
export const useNomenclatorTabs = (): NavItemType[] => {
	const { user } = useAuthContext();
	const { t } = useTranslation();

	return useMemo(() => {
		const allTabs =
			navigation.items
				.find((group) => group.id === 'group-administrare')
				?.children?.find((node) => node.id === 'nomenclatoare')?.children ?? [];

		return allTabs
			.filter((tab) =>
				hasPermission(user, tab.requiredPermission, tab.requiredPermissionMode ?? 'any')
			)
			.map((tab) => ({
				...tab,
				// String-urile fără cheie trec neschimbate prin t() (i18next întoarce cheia).
				title: typeof tab.title === 'string' ? t(tab.title) : tab.title
			}));
	}, [user, t]);
};
